// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1d5B9","content":"LayoutSettings_content__O8vv8"};